import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import config from 'config';
// material-ui
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import CableIcon from '@mui/icons-material/Cable';
import HomeIcon from '@mui/icons-material/Home';
// project imports
import LogoSection from '../LogoSection';

import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import Logo from 'ui-component/Logo';
import Tooltip from '@mui/material/Tooltip';
// assets
import { IconMenu2 } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';
// ==============================|| MAIN NAVBAR / HEADER ||============================== //

 const Header = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();
     const navigate = useNavigate();
    const handleOffRoad = () => {
        navigate("/apps/iot/list");
    };
    const handlepowertrain = () =>{
        navigate("/apps/iot/Config")
    };
    // const handlecommercial= () => {
    //     navigate("/apps/iot/page2");
    // };
    const handlecommercial= () => {
        navigate("/apps/iot/Status");
    };
    const handleelectrical= () => {
        navigate("/apps/iot/Operational");
    };
    const handledisplay = () => {
        navigate("/apps/iot/table");
    };
    const handleindustrial= () => {
        navigate("/apps/iot/Real-time-monitoring");
    };
    const handlemanufacturing = () => {
        navigate("/apps/iot/Thresholds");
    };
    const handleinformation = () => {
        navigate("/apps/iot/Alerts");
    };
    const handlehome= () => {
        navigate("/");
    };
    
    return (
        <>
        <ButtonBase disableRipple component={Link} to={config.defaultPath}>
        <Logo />
    </ButtonBase>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </Box>

            {/* header search */}
            {/* <SearchSection /> */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
            {/* <NotificationSection />
            <ProfileSection /> */}
            {/* <a href="https://www.arigs.com/contact/">
            <Button variant="contained" sx={{color:"#fff",cursor:'pointer'}} disableElevation>
                Contact Us
            </Button>
            </a> */}
            {/* <Tooltip disableFocusListener disableTouchListener title="Home">
            <Button a href="/apps/iot/">
            <HomeIcon  sx={{ color: 'rgba(0, 0, 0, 0.54)' }} className="IconHover" />
            </Button>
            </Tooltip>
            <Tooltip disableFocusListener disableTouchListener title="OffRoad Vehicle Systems">
            <Button a href="/apps/iot/reusable">
            <EmojiTransportationIcon  sx={{ color: 'rgba(0, 0, 0, 0.54)' }} className="IconHover" />
            </Button>
            </Tooltip>
            <Tooltip disableFocusListener disableTouchListener title="Powertrain - Drivetrain Solutions">
            <Button a href="/apps/iot/page1">
             <CableIcon   sx={{ color: 'rgba(0, 0, 0, 0.54)' }} className="IconHover" />
             </Button>
             </Tooltip>
             <Tooltip disableFocusListener disableTouchListener title="Commercial Vehicle Systems">
             <Button a href="/apps/iot/page2">
             <AirportShuttleIcon  sx={{ color: 'rgba(0, 0, 0, 0.54)' }} className="IconHover" />
             </Button>
             </Tooltip>
             <Tooltip disableFocusListener disableTouchListener title="Electrical - Electronic Systems">
             <Button a href="/apps/iot/page3">
             <DeveloperBoardIcon   sx={{ color: 'rgba(0, 0, 0, 0.54)' }} className="IconHover" />
             </Button>
             </Tooltip>
             <Tooltip disableFocusListener disableTouchListener title="Display System Solutions">
             <Button a href="/apps/iot/table">
             <DisplaySettingsIcon  sx={{ color: 'rgba(0, 0, 0, 0.54)' }} className="IconHover" />
             </Button>
             </Tooltip>
             <Tooltip disableFocusListener disableTouchListener title="Industrail Automation Systems">
             <Button a href="/apps/iot/tabs">
             <AutoModeIcon  sx={{ color: 'rgba(0, 0, 0, 0.54)' }} className="IconHover" />
             </Button>
             </Tooltip>
             <Tooltip disableFocusListener disableTouchListener title="Manufacturing Engineering">
             <Button a href="/apps/iot/manufacture">
             <PrecisionManufacturingIcon   sx={{ color: 'rgba(0, 0, 0, 0.54)' }} className="IconHover" />
             </Button>
             </Tooltip>
             <Tooltip disableFocusListener disableTouchListener title="Information System and Solutions">
             <Button a href="/apps/iot/software">
             <SmartphoneIcon  sx={{ color: 'rgba(0, 0, 0, 0.54)' }} className="IconHover" />
             </Button>
             </Tooltip> */}
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
